console.log("bundle.js loaded");

import {slideUp, slideDown} from 'es6-slide-up-down';
import {onPageShow} from './on-page-show.js';

const html = document.documentElement;
const body = document.body;

let productsJSONCache = {};

async function loadProductJson(product_id)
{
    try
    {
        const response = await fetch("/json/bundle-product/"+product_id);
        if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

        const data = await response.json();
        productsJSONCache[product_id] = data;
        return data;
    }
    catch (error)
    {
        console.error('Failed to fetch product data:', error);
        throw error;
    }

}

async function getProductJson(product_id)
{
    if (productsJSONCache[product_id])
    {
        return productsJSONCache[product_id];
    }
    else
    {
        const data = await loadProductJson(product_id);
        productsJSONCache[product_id] = data;
        return data;
    }
}

function buildSizeQuantitySelector(size)
{
    const template = document.querySelector("#templates .size_quantity_selector");
    let newSelector = template.cloneNode(true);
    let label = newSelector.querySelector("label.size");
    let quantitySelector = newSelector.querySelector(".quantity_selector");
    let input = quantitySelector.querySelector("input[type=number]");
    let footerSlot = newSelector.querySelector(".footer_slot");
    let alternatives_link = newSelector.querySelector(".alternatives_link");

    let id ="size_qty_selector_"+size.variant_id;
    label.setAttribute("for",id);
    label.innerHTML = size.name;
    input.id = "size_qty_selector_"+id;
    input.setAttribute("name",size.variant_id);
    input.setAttribute("max",size.max);

    return newSelector.outerHTML;
}

async function buildAvailableSizesAndQuantitiesHTML(product_id, colourId)
{
    //console.log("Building available sizes and quantities for product "+product_id+" colour "+colourId);
    let html = "";
    let product_json = await getProductJson(product_id);
    if (product_json && product_json.hasOwnProperty("colours"))
    {
        product_json.colours.forEach(colour => {
            if (colour.id == colourId)
            {
                //console.log("found",colour.name);
                if (colour.hasOwnProperty("sizes"))
                {
                    colour.sizes.forEach(size => 
                    {
                        html+=buildSizeQuantitySelector(size);
                    });
                }
                //console.log(colour.sizes);
            }
        });
    }
    if (html=="")
    {
        html = "<p class=\"red_text\">Sorry, there are no sizes available for your chosen colour.</p>";
    }
    return html;
}

document.addEventListener("DOMContentLoaded", () => {

    const bundleSteps = document.querySelectorAll(".bundle_step:not(.completion)");
    const bundleCompletionStep = document.querySelector(".bundle_step.completion");
    const bundleCompletionMessages = document.querySelector(".completion_messages");
    const submitButtons = bundleCompletionStep.querySelectorAll("input[type='submit']");

    document.addEventListener("click", e => {
        if (e.target.hasAttribute("data-scroll-to-step"))
        {
            const stepIdToScrollTo = e.target.getAttribute("data-scroll-to-step");
            const stepToScrollTo = document.querySelector(".bundle_step[data-step='"+stepIdToScrollTo+"']");
            console.log(stepIdToScrollTo);
            var offset = 100; // pixels
            if (!window.isMobile)
            {
                offset = 110;
            }

            const elementTop = stepToScrollTo.getBoundingClientRect().top + window.scrollY;

            window.scrollTo({
            top: elementTop - offset,
            behavior: 'smooth'
            });
        }
    });

    bundleCompletionStep.addEventListener("update", e => {
        let canProceed = true;
        let messages = [];
        bundleSteps.forEach(bundleStep => {
            const counter = bundleStep.querySelector("span.count");
            const stepNumber = bundleStep.getAttribute("data-step");
            const pluralString = bundleStep.getAttribute("data-string-plural");
            if (counter.classList.contains("done"))
            {

            }
            else
            {
                canProceed = false;
                if (counter.classList.contains("error"))
                {
                    messages.push({"class":"error","message":"You have added too many <a data-scroll-to-step='"+stepNumber+"'>"+pluralString+"</a>"});
                    console.log("error");
                }
                else
                {
                    messages.push({"class":"warning","message":"You need to add more <a data-scroll-to-step='"+stepNumber+"'>"+pluralString+"</a>"});
                    console.log("incomplete");
                }
            }
        });
        if (canProceed)
        {
            messages.push({"class":"done","message":"All products added, ready to add your logo"});
            submitButtons.forEach(btn => btn.disabled = false);
        }
        else
        {
            submitButtons.forEach(btn => btn.disabled = true);
        }
        if (messages.length)
        {
            bundleCompletionMessages.innerHTML = "";
            messages.forEach(message => {
                const messageLi = document.createElement("li");
                messageLi.innerHTML = message.message;
                messageLi.className = message.class;
                bundleCompletionMessages.appendChild(messageLi);
            });
        }

    });

    bundleSteps.forEach(bundleStep => {

        const stepId = bundleStep.getAttribute("data-step");
        const counter = bundleStep.querySelector("span.count");
        const stepTitle = bundleStep.querySelector(".step_heading h2");

        const productSelectionRows = bundleStep.querySelectorAll(".product_selection_row");
        const sizeAndQuantitySelectorContainers = bundleStep.querySelectorAll(".size_and_quantity_selectors");

        if (productSelectionRows.length)
        {
            const totalRequired = counter.getAttribute("data-total-required");
            counter.addEventListener("update", e => {
                const visibleProductSelectionRows = bundleStep.querySelectorAll(".product_selection_row.visible");
                const visibleQuantityFields = bundleStep.querySelectorAll(".quantity_selector_quantity_field");
                let totalQuantity = 0;
                visibleQuantityFields.forEach(quantityField => {
                    totalQuantity+=parseInt(quantityField.value);
                });
                counter.innerHTML = "<strong>"+totalQuantity+"</strong> / <strong>"+totalRequired+"</strong> Selected";
                counter.classList.remove("done","incomplete","error");
                stepTitle.classList.remove("done","incomplete","error");
                counter.classList.add("modified");2
                // Force a reflow to restart the animation
                void counter.offsetWidth;
                void stepTitle.offsetWidth;
                if(totalQuantity==0)
                {
                    //do nothing
                }
                else if (totalQuantity < totalRequired)
                {
                    counter.classList.add("incomplete");
                    stepTitle.classList.add("incomplete");
                }
                else if (totalQuantity==totalRequired)
                {
                    counter.classList.add("done");
                    stepTitle.classList.add("done");
                }
                else
                {
                    counter.classList.add("error");
                    stepTitle.classList.add("error");
                }
                bundleCompletionStep.dispatchEvent(new Event('update'));
            });


            productSelectionRows.forEach(productSelectionRow => {
                const productInputs = productSelectionRow.querySelectorAll("input.product_radio");
                const colourSelectorChoices = productSelectionRow.querySelector(".colour_selector_choices");
                const productSelectionRowId = productSelectionRow.getAttribute("data-product-selection-row");
                const sizeAndQuantitySelectors = productSelectionRow.querySelector(".size_and_quantity_selectors");
                const sizeGuideModal = document.querySelector("#modals_container aside.modal[data-modal-id='size_guide_"+productSelectionRowId+"']");
                const sizeGuideButton = productSelectionRow.querySelector("button.size");

                productInputs.forEach(productInput => {
                    // const productSelectionRow = productInput.closest(".product_selection_row");

                    productInput.addEventListener('change', async e => {
                        const selectedInput = productSelectionRow.querySelector("input[type='radio']:checked");
                        const selectedValue = selectedInput?.value;
                        if (selectedValue)
                        {
                            productSelectionRow.classList.add("product_selected");
                            sizeAndQuantitySelectors.innerHTML = "<p class='placeholder'>"+sizeAndQuantitySelectors.getAttribute("data-placeholder-text")+"</p>";
                            colourSelectorChoices.classList.add("loading");
                            const productData = await getProductJson(selectedValue);

                            //because we may have waited for the above, check again to make sure the user hasn't clicked on another choice while waiting
                            //if they have, load their new choice

                            const selectedInputNow = productSelectionRow.querySelector("input[type='radio']:checked");
                            const selectedValueNow = selectedInputNow?.value;

                            if (selectedValueNow!=selectedValue)
                            {
                                if (selectedValueNow)
                                {
                                    selectedInputNow.dispatchEvent(new Event('change'));
                                }
                                return false;
                            }

                            if (productData && productData.hasOwnProperty("colours"))
                            {
                                let coloursHTML = "";
                                productData.colours.forEach(colour => {
                                    coloursHTML+=colour.colour_selector_html;
                                });
                                const temporaryContainer = document.createElement("div");
                                temporaryContainer.innerHTML=coloursHTML;

                                const colourInputs = temporaryContainer.querySelectorAll("input[type='radio']");
                                if (colourInputs)
                                {
                                    colourInputs.forEach(colourInput => {
                                        colourInput.setAttribute("name","colour_"+productSelectionRowId); 
                                    });
                                }
                                colourSelectorChoices.innerHTML=temporaryContainer.innerHTML;

                                if (productData.hasOwnProperty('size_guide_html') &&
                                    productData.size_guide_html !== '')
                                {
                                    sizeGuideModal.querySelector(".modal_content").innerHTML = productData.size_guide_html;
                                    sizeGuideButton.classList.remove("hidden");
                                }
                                else
                                {
                                    sizeGuideModal.querySelector(".modal_content").innerHTML = "";
                                    sizeGuideButton.classList.add("hidden");
                                }

                                
                                //do we want to auto click the first colour?
                                // const firstColourInput = colourSelectorChoices.querySelector("input[type=radio]");
                                // firstColourInput.checked = true;
                                // firstColourInput.dispatchEvent(new Event('change'));
                                colourSelectorChoices.classList.remove("loading");
                            }
                            else
                            {
                                window.modal("<p>Please try again or make a different selection.</p>","Sorry, there was a problem");
                            }
                        }
                        counter.dispatchEvent(new Event('update'));
                    });
                });

                colourSelectorChoices.addEventListener('change', async e => {
                    const target = e.target;
                    if (target && target.matches('input[type="radio"]'))
                    {
                        const selectedProductInput = productSelectionRow.querySelector("input[type='radio']:checked");
                        const selectedProductValue = selectedProductInput?.value;
                        const selectedProductThumbnail = selectedProductInput.closest("label.product_checkbox").querySelector(".image_container img");
                        const selectedColourInput = colourSelectorChoices.querySelector("input[type='radio']:checked");
                        const selectedColourValue = selectedColourInput?.value;
                        if (selectedProductValue && selectedColourValue)
                        {
                            console.log(selectedColourInput.getAttribute("data-thumbnail"));
                            if (selectedColourInput.getAttribute("data-thumbnail"))
                            {
                                selectedProductThumbnail.src = selectedColourInput.getAttribute("data-thumbnail");
                            }
                            const sizeAndquantitySelectorHTML = await buildAvailableSizesAndQuantitiesHTML(selectedProductValue, selectedColourValue);
                            sizeAndQuantitySelectors.innerHTML = sizeAndquantitySelectorHTML;
                        }
                    }
                    counter.dispatchEvent(new Event('update'));
                });
            });
        }

        

        //size and quantity selectors

        sizeAndQuantitySelectorContainers.forEach(sizeAndQuantitySelectorContainer => {
            sizeAndQuantitySelectorContainer.addEventListener('change',(event) => {
                if (event.target)
                {
                    if (event.target.classList.contains('quantity_selector_quantity_field'))
                    {
                        const quantityField = event.target;
                        const sizeQuantitySelector = quantityField.closest(".size_quantity_selector");
                        if (quantityField.value < 1)
                        {
                            sizeQuantitySelector.classList.remove("active");
                        }
                        else
                        {
                            sizeQuantitySelector.classList.add("active");
                        }

                        counter.dispatchEvent(new Event('update'));
                    }
                }
            });
        });

        const addMoreLink = bundleStep.querySelector(".add_more_link");

        if (addMoreLink)
        {
            addMoreLink.addEventListener("click", e => {
                e.preventDefault();
                if (!addMoreLink.classList.contains("disabled"))
                {
                    let nextProductRowContainerToShow = bundleStep.querySelector('.product_selection_row_container:not(.visible)');
                    if (nextProductRowContainerToShow)
                    {
                        slideDown(nextProductRowContainerToShow, 200);
                        nextProductRowContainerToShow.classList.add("visible");
                        nextProductRowContainerToShow = bundleStep.querySelector('.product_selection_row_container:not(.visible)');
                    }
                    if (!nextProductRowContainerToShow)
                    {
                        addMoreLink.classList.add("disabled");
                    }
                }
            });
        }

    });

    // If this page was loaded in "edit" mode with pre-filled selections, force a
    // one-off "change" on every already-populated quantity field - the existing
    // delegated listener on each size_and_quantity_selectors container reacts to
    // this by toggling that field's "active" class AND recomputing its step's
    // completion counters, so both catch up to the server-rendered values already
    // in the DOM without us replaying any clicks/fetches or duplicating that logic.
    if (document.querySelector("form[data-editing]"))
    {
        document.querySelectorAll(".quantity_selector_quantity_field").forEach(field => {
            field.dispatchEvent(new Event('change', {bubbles: true}));
        });
    }

        //scrolling header behaviour
    window.addEventListener('scroll', () => {
        // Get the current vertical scroll position
        const scrollTop = window.scrollY || html.scrollTop;
        const bundleTitles = document.querySelectorAll(".step_heading");
        const headerTrustMessaging = document.getElementById("header_trust_messaging");
        const stuckBundleTitles = document.querySelectorAll(".step_heading.stuck");

        bundleTitles.forEach(bundleTitle => {
            const titleTop = bundleTitle.getBoundingClientRect().top;
            let topOfPage = 100;
            if (window.isMobile)
            {
                topOfPage = 80;
            }

            if (titleTop <= topOfPage)
            {
                bundleTitle.classList.add("stuck");
                headerTrustMessaging.classList.add("no_shadow");
            }
            else
            {
                bundleTitle.classList.remove("stuck");
                headerTrustMessaging.classList.remove("no_shadow");
            }
        });
        if (stuckBundleTitles.length)
        {
            headerTrustMessaging.classList.add("no_shadow");
        }
        else
        {
            headerTrustMessaging.classList.remove("no_shadow");
        }


    });
    onPageShow(function (event) {
        window.dispatchEvent(new Event('scroll'));
    });
    

});